// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif",

    h1: {
      fontFamily: "Inter Tight, sans-serif",
      fontWeight: 800,
      lineHeight: 1.1,
      letterSpacing: "-0.02em",
      fontSize: "4.5rem", // desktop
    },

    overline: {
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      letterSpacing: "0.12em",
      textTransform: "none",
      fontSize: "1.05rem",
    },
  },
});

export default theme;
